module.exports = __webpack_public_path__ + "static/media/teeth.047169e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/teeth.png
// module id = 115
// module chunks = 0